import React from 'react';

type List = {
  value: string | number;
  name: string | number;
  allow?: boolean;
};

type Props = {
  label: string;
  list: List[];
  value: any;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  disable?: boolean;
};

const SelectTemplate = (props: Props) => {
  const { label, list, value, onChange, placeholder, disable } = props;

  return (
    <div className="space-y-2">
      <label className="block text-[13px] font-medium text-gray-700">{label}</label>
      <select
        value={value}
        onChange={onChange}
        disabled={disable}
        className=" m-0 block w-full p-2 border border-gray-300 bg-white rounded-md shadow-sm focus:ring-goldenYellow focus:border-goldenYellow sm:text-sm"
      >
        {placeholder && <option value="">{placeholder}</option>}
        {(list ?? []).map(
          (indv) =>
            indv?.allow !== false && (
              <option key={indv?.value} value={indv?.value}>
                {indv?.name}
              </option>
            )
        )}
      </select>
    </div>
  );
};

export default SelectTemplate;
